import React from "react";
import Container from "../../utils/Container";
import HerotopCarousel from "../../utils/carousels/HerotopCarousel";

import "../../../css/herotop.css";

const HeroTop = (props) => {
  return (
    <header className=" ">
      <Container classe="marginNavbar bg-secondary rounded-bl-xl rounded-br-xl py-20 md:py-14 pb-36">
        <HerotopCarousel />
      </Container>
    </header>
  );
};

export default HeroTop;
